import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { toBrazilianFullDate } from 'views/CRM/shared/utils/date';

const ModalLeadInfo = ({ lead, openAutomatically = false }) => {
  const [modalIsOpen, setModalIsOpen] = useState(openAutomatically);

  useEffect(() => {
    if (openAutomatically) {
      setModalIsOpen(true);
    }
  }, [openAutomatically]);

  const toggleModal = () => {
    setModalIsOpen(!modalIsOpen);
  };

  const dateCreate = lead?.createdAt ? toBrazilianFullDate(lead.createdAt) : '';

  const lastUpdate = lead?.lastUpdatedAt
    ? toBrazilianFullDate(lead.lastUpdatedAt)
    : '';

  const firstContactDate = lead?.firstContactDate
    ? toBrazilianFullDate(lead.firstContactDate)
    : '';

  const associationDate = lead?.associationDate
    ? toBrazilianFullDate(lead.associationDate)
    : '';

  return (
    <>
      <Button
        color="info"
        size="sm"
        title="Ver Informações"
        onClick={toggleModal}
        className="ml-1"
      >
        <i className="fas fa-info-circle"></i>
      </Button>

      <Modal isOpen={modalIsOpen} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>Informações do Lead</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-6">
              <p>
                <strong>Nome: </strong>
                {lead?.name || '-'}
              </p>
              <p>
                <strong>Telefone: </strong>
                {lead?.phone ? `${lead?.ddi || ''} ${lead.phone}` : '-'}
              </p>
              <p>
                <strong>Fase: </strong>
                {lead?.stageName || '-'}
              </p>
              <p>
                <strong>Responsável: </strong>
                {lead?.responsibleName || '-'}
              </p>
              <p>
                <strong>Criado por: </strong>
                {lead?.createdByName || '-'}
              </p>
              <p>
                <strong>Data de criação: </strong>
                {dateCreate}
              </p>
              <p>
                <strong>Última atualização: </strong>
                {lastUpdate}
              </p>
            </div>
            <div className="col-md-6">
              <p>
                <strong>Origem da Interação: </strong>
                {lead?.channelOrigin || '-'}
              </p>
              <p>
                <strong>Data do Primeiro Contato: </strong>
                {firstContactDate}
              </p>
              <p>
                <strong>Gerou Oportunidade: </strong>
                {lead?.isConverted ? 'Sim' : 'Não'}
              </p>
              <p>
                <strong>Gerado Manualmente: </strong>
                {lead?.isManual ? 'Sim' : 'Não'}
              </p>
              <p>
                <strong>Operador que Associou: </strong>
                {lead?.associatedBy || '-'}
              </p>
              <p>
                <strong>Data de Associação: </strong>
                {associationDate}
              </p>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleModal}>
            Fechar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default ModalLeadInfo;
